const { VITE_ASSETS_URL } = import.meta.env;

export const s3FontList = [
  {
    name: 'Poppins',
    list: [
      'Regular',
      'Black',
      'BlackItalic',
      'Bold',
      'BoldItalic',
      'ExtraBold',
      'ExtraBoldItalic',
      'ExtraLight',
      'ExtraLightItalic',
      'Italic',
      'Light',
      'LightItalic',
      'Medium',
      'MediumItalic',
      'SemiBold',
      'SemiBoldItalic',
      'Thin',
      'ThinItalic',
    ],
    folder: 'Poppins',
  },
  {
    name: 'Kalam',
    list: ['Regular', 'Bold', 'Light'],

    folder: 'Kalam',
  },
  {
    name: 'Merienda',
    list: ['Regular', 'Black', 'Bold', 'ExtraBold', 'Light', 'Medium', 'SemiBold'],
    folder: 'Merienda',
  },
  {
    name: 'Noto Serif',
    list: [
      'Black',
      'BlackItalic',
      'Bold',
      'BoldItalic',
      'ExtraBold',
      'ExtraBoldItalic',
      'ExtraLight',
      'ExtraLightItalic',
      'Italic',
      'Light',
      'LightItalic',
      'Medium',
      'MediumItalic',
      'Regular',
      'SemiBold',
      'SemiBoldItalic',
      'Thin',
      'ThinItalic',
    ],
    folder: 'Noto_Serif',
  },
  {
    name: 'Open Sans',
    list: [
      'Regular',
      'Bold',
      'BoldItalic',
      'ExtraBold',
      'ExtraBoldItalic',
      'Italic',
      'Light',
      'LightItalic',
      'Medium',
      'MediumItalic',
      'SemiBold',
      'SemiBoldItalic',
    ],
    folder: 'OpenSans',
  },
  {
    name: 'Public Sans',
    list: [
      'Regular',
      'Black',
      'BlackItalic',
      'Bold',
      'BoldItalic',
      'ExtraBold',
      'ExtraBoldItalic',
      'ExtraLight',
      'ExtraLightItalic',
      'Italic',
      'Light',
      'LightItalic',
      'Medium',
      'MediumItalic',
      'SemiBold',
      'SemiBoldItalic',
      'Thin',
      'ThinItalic',
    ],
    folder: 'Public_Sans',
  },
  {
    name: 'Reenie Beanie',
    list: ['Regular'],
    folder: 'Reenie_Beanie',
  },
  {
    name: 'Sacramento',
    list: ['Regular'],
    folder: 'Sacramento',
  },
  {
    name: 'Ubuntu',
    list: ['Regular', 'Bold', 'BoldItalic', 'Italic', 'Light', 'LightItalic', 'Medium', 'MediumItalic'],
    folder: 'Ubuntu',
  },
  {
    name: 'Mali',
    list: [
      'Bold',
      'BoldItalic',
      'ExtraLight',
      'ExtraLightItalic',
      'Italic',
      'Light',
      'LightItalic',
      'Medium',
      'MediumItalic',
      'Regular',
      'SemiBold',
      'SemiBoldItalic',
    ],
    folder: 'mali',
  },
  {
    name: 'Crimson Pro',
    list: [
      'Black',
      'BlackItalic',
      'Bold',
      'BoldItalic',
      'ExtraBold',
      'ExtraBoldItalic',
      'ExtraLight',
      'ExtraLightItalic',
      'Italic',
      'Light',
      'LightItalic',
      'Medium',
      'MediumItalic',
      'Regular',
      'SemiBold',
      'SemiBoldItalic',
    ],
    folder: 'Crimson_pro',
  },
  {
    name: 'Neuton',
    list: ['Bold', 'ExtraBold', 'ExtraLight', 'Italic', 'Light', 'Regular'],
    folder: 'Neuton',
  },
  {
    name: 'Bellota Text',
    list: ['Bold', 'BoldItalic', 'Italic', 'Light', 'LightItalic', 'Regular'],
    folder: 'Bellota_text',
  },
  {
    name: 'Shantell Sans',
    list: [
      'Bold',
      'BoldItalic',
      'ExtraBold',
      'ExtraBoldItalic',
      'Italic',
      'Light',
      'LightItalic',
      'Medium',
      'MediumItalic',
      'Regular',
      'SemiBold',
      'SemiBoldItalic',
    ],
    folder: 'Shantell_sans',
  },
];

export const getFontProps = (fontWeight: string): FontFaceDescriptors | null => {
  switch (fontWeight) {
    case 'Black':
      return { weight: '900', style: 'normal' };
    case 'BlackItalic':
      return { weight: '900', style: 'italic' };
    case 'ExtraBold':
      return { weight: '800', style: 'normal' };
    case 'ExtraBoldItalic':
      return { weight: '800', style: 'italic' };
    case 'Bold':
      return { weight: '700', style: 'normal' };
    case 'BoldItalic':
      return { weight: '700', style: 'italic' };
    case 'SemiBold':
      return { weight: '600', style: 'normal' };
    case 'SemiBoldItalic':
      return { weight: '600', style: 'italic' };
    case 'Medium':
      return { weight: '500', style: 'normal' };
    case 'MediumItalic':
      return { weight: '500', style: 'italic' };
    case 'Regular':
      return { weight: '400', style: 'normal' };
    case 'Italic':
      return { weight: '400', style: 'italic' };
    case 'Light':
      return { weight: '300', style: 'normal' };
    case 'LightItalic':
      return { weight: '300', style: 'italic' };
    case 'ExtraLight':
      return { weight: '200', style: 'normal' };
    case 'ExtraLightItalic':
      return { weight: '200', style: 'italic' };
    case 'Thin':
      return { weight: '100', style: 'normal' };
    case 'ThinItalic':
      return { weight: '100', style: 'italic' };
    default:
      return null;
  }
};

export const loadAllFont = () => {
  s3FontList.forEach((fontItem) => {
    fontItem.list.forEach((fontWeight) => {
      // const props = getFontProps(fontWeight);
      // if (props) {
      //   const fontFile = new FontFace(
      //     `${fontItem.name}`,
      //     `url(${VITE_ASSETS_URL}/fonts/${fontItem.folder}/${fontItem.name.replaceAll(' ', '')}-${fontWeight}.ttf)`,
      //     props,
      //   );
      //   document.fonts.add(fontFile);
      //   fontFile.load().catch((err) => {
      //     console.log(err);
      //   });
      // }

      if (fontWeight !== 'Regular') {
        const props = getFontProps(fontWeight);
        if (props) {
          const f = new FontFace(
            `${fontItem.name} Regular`,
            `url(${VITE_ASSETS_URL}/fonts/${fontItem.folder}/${fontItem.name.replaceAll(' ', '')}-${fontWeight}.ttf)`,
            props,
          );
          document.fonts.add(f);
          f.load().catch((err) => {
            console.log(err);
          });
        }
      }

      const fontFile = new FontFace(
        `${fontItem.name} ${fontWeight}`,
        `url(${VITE_ASSETS_URL}/fonts/${fontItem.folder}/${fontItem.name.replaceAll(' ', '')}-${fontWeight}.ttf)`,
      );
      document.fonts.add(fontFile);
      fontFile.load().catch((err) => {
        console.log(err);
      });
    });
  });
};
